import React from "react";

type PropsType = {
  id?: any;
  petName?: any;
  date?: string;
  riskLevel?: string;
  riskValue?: any;
  result?: any;
};

const LabResultRow = ({ id, petName, date, riskLevel, result }: PropsType) => {
  const reportDownloadHandler = () => {
    const fileUrl = result.file;

    // Option 1: Using window.open (this opens the file in a new tab)
    window.open(fileUrl, "_blank");
  };

  const dateConversion = (dateStr: any) => {
    const dateObj = new Date(dateStr);

    const day = dateObj.getUTCDate().toString().padStart(2, "0");
    const month = (dateObj.getUTCMonth() + 1).toString().padStart(2, "0");
    const year = dateObj.getUTCFullYear().toString();

    const formattedDate = `${month}-${day}-${year}`;
    return formattedDate;
  };

  return (
    <>
      <hr className="tw-w-[90%] tw-mt-2 tw-mb-2" />
      <div className="tw-flex tw-items-center tw-justify-between tw-pb-2">
        <div className="tw-flex-1 tw-text-lg tw-text-[#000000] tw-font-normal">
          {petName?.petName && petName?.petName !== "" ? petName?.petName : "None"}
        </div>
        <div className="tw-flex-1 tw-text-xl  tw-text-[#000000] tw-font-normal">
          {date ? dateConversion(date) : "None"}
        </div>
        <div className="tw-flex-1 tw-text-xl tw-text-[#000000] tw-font-normal">{result?.kitId?.code}</div>
        <div className="tw-flex-1 tw-text-xl tw-text-[#000000] tw-font-normal">{riskLevel ? riskLevel : "Pending"}</div>

        <div className="tw-flex tw-flex-1">
          {result.submit ? (
            <button
              className="tw-flex tw-items-center tw-justify-center tw-text-lg tw-text-[#FFFFFF] tw-font-bold tw-bg-[#FF7B6D] tw-py-2 tw-px-8 tw-rounded-md"
              onClick={() => reportDownloadHandler()}
            >
              Download
            </button>
          ) : (
            <button className="tw-flex tw-items-center tw-justify-center tw-text-lg  tw-font-bold tw-bg-[transparent] tw-border tw-text-[#FF7B6D] tw-border-[#FF7B6D] tw-py-2 tw-px-8 tw-rounded-md">
              Pending
            </button>
          )}
        </div>
      </div>
    </>
  );
};

export default LabResultRow;
